import { z } from 'zod';
import { authTypes } from '@/app/login/types';

export type AllowedKeys =
  | 'edit_email'
  | 'edit_phone'
  | 'setup_profile'
  | 'login_profile';

export const ediSchema = z.object({
  value: z.coerce.string(),
});

export const setupProfileSchema = z.object({
  type: authTypes,
  value: z.coerce.string(),
});

export const loginProfileSchema = z.object({
  type: authTypes,
  value: z.coerce.string(),
});

export type EditEmailProps = z.infer<typeof ediSchema>;
export type EditPhoneProps = z.infer<typeof ediSchema>;
export type SetupProfileInfoProps = z.infer<typeof setupProfileSchema>;
export type LoginProfileInfoProps = z.infer<typeof loginProfileSchema>;
